module.exports = __webpack_public_path__ + "static/media/12.2e12a3a1.jpg";